"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dictionaries = void 0;
const core_1 = require("../core");
class Dictionaries extends core_1.CrowdinApi {
    listDictionaries(projectId, options) {
        if ((0, core_1.isOptionalString)(options)) {
            options = { languageIds: options };
        }
        let url = `${this.url}/projects/${projectId}/dictionaries`;
        url = this.addQueryParam(url, 'languageIds', options.languageIds);
        return this.get(url, this.defaultConfig());
    }
    /**
     * @param projectId project identifier
     * @param languageId language identifier
     * @param request request body
     * @see https://support.crowdin.com/api/v2/#operation/api.projects.dictionaries.patch
     */
    editDictionary(projectId, languageId, request) {
        const url = `${this.url}/projects/${projectId}/dictionaries/${languageId}`;
        return this.patch(url, request, this.defaultConfig());
    }
}
exports.Dictionaries = Dictionaries;
